import config from '@plone/registry';
import HeaderSlim from '@redturtle/qubicaamf-theme/components/Header/HeaderSlim';
import Navigation from '@redturtle/qubicaamf-theme/components/Header/Navigation';
import SearchContact from '@redturtle/qubicaamf-theme/components/Header/SearchContact';
import { Container as SemanticContainer } from 'semantic-ui-react';
import minilogo from '@redturtle/qubicaamf-theme/assets/qubicaminilogo.png';
import styles from '@redturtle/qubicaamf-theme/components/Header/styles.module.css';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const Container =
    config.getComponent('Container').component || SemanticContainer;
  const Image = config.getComponent('Image').component;

  const [searchIsVisible, setSearchIsVisible] = useState<boolean>(false);

  return (
    <div className="header-wrapper public-ui" role="banner">
      <Container>
        <HeaderSlim />
        <div className={styles.navigation} id="navigation">
          <div className={styles['navigation-left']}>
            <div className={styles.logo_nav_wrapper}>
              <div className={styles.logo}>
                <NavLink to="/">
                  <Image src={minilogo} alt="Qubica AMF Logo" />
                </NavLink>
              </div>
            </div>
            <Navigation searchIsVisible={searchIsVisible} />
          </div>
          <SearchContact
            searchIsVisible={searchIsVisible}
            setSearchIsVisible={setSearchIsVisible}
          />
        </div>
      </Container>
    </div>
  );
}
